import React from 'react';

import { IconButton, SvgIcon } from '@material-ui/core';

import styles from './ControlButton.module.scss';

export interface ControlButtonProps {
	/* Path to the SVG icon */
	icon: React.ElementType;
	ariaLabel: string;
	size: 'xsmall' | 'small' | 'medium' | 'large';
	onClick: () => void;
	type?: 'dark' | 'light';
}

export const ControlButton = ({
	type = 'light',
	size,
	icon,
	ariaLabel,
	onClick,
}: ControlButtonProps) => {
	let rootClass;
	const iconClass = [styles[`control-btn__icon--${type}`]];
	switch (size) {
		case 'xsmall':
			rootClass = styles['control-btn--xsmall'];
			iconClass.push(styles['control-btn__icon--xsmall']);
			break;
		case 'small':
			rootClass = styles['control-btn--small'];
			iconClass.push(styles['control-btn__icon--small']);
			break;
		case 'medium':
			rootClass = styles['control-btn--medium'];
			iconClass.push(styles['control-btn__icon--medium']);
			break;
		case 'large':
			rootClass = styles['control-btn--large'];
			iconClass.push(styles['control-btn__icon--large']);
			break;
		default:
			throw new Error(`Unknown ControlButton size: ${size}`);
	}

	return (
		<IconButton
			classes={{ root: rootClass }}
			aria-label={ariaLabel}
			focusRipple
			onClick={onClick}
		>
			<SvgIcon
				component={icon}
				className={iconClass.join(' ')}
				alt={ariaLabel}
			/>
		</IconButton>
	);
};
